// extracted by mini-css-extract-plugin
export default {"services":"Services_services__tAD+k","services_premium_type":"Services_services_premium_type__2XJLJ","services_standar_type":"Services_services_standar_type__luS+D"};